/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/13/19
 * Time: 3:34 PM
 */
import React, {Component} from 'react';
import {MDBModal, MDBModalHeader} from "mdbreact";
import './Registration.css';
import {Button, Checkbox, Form} from "semantic-ui-react";
import TxtLbl from "../../components/Input/Input/TxtLbl";
import {Col, Row} from "reactstrap";
// import * as Validator from "../../util/Validator";
import DrpDwn from "../../components/Dropdown/Dropdown/DrpDwn";
import * as DropDownConst from "../../store/Reducer/DropDownConst";
import regis_icon from '../../assets/img/registration/registration.png'
import * as common from '../../const/Common/CommonFunc'
import * as EmailValidator from "email-validator";
import queryString from 'query-string';
import axios from "../../axios/axios_visitortag";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import JWT_Decode from "jwt-decode";
import success_icon from "../../assets/img/sweet/success.svg";
import * as util from '../../util/Validator';
import VisitorPhotoUpload from "../../components/VisitorPhotoUpload/VisitorPhotoUpload_";
import ImageUpload from "../../components/ImageUploader/ImageUploader_";
import apiConfig from "../../axios/axios_api_services";

class App extends Component {
  state = {
    title: 'Mr',
    fname: '',
    lname: '',
    gender: 'Male',
    mobile: '',
    email: '',
    company: '',
    department: '',
    designation: '',
    extention: '',
    identification_type: 'NIC',
    identification_value: '',
    mvid: '',
    refid: '',
    pin: '',
    access: true,
    token: null,
    isPin: false,
    isTerms: false,
    isClear: false,
    warning_msg: "Registration completed successfully.",
    screenshot: "",
    isWebCam: true,
    isChoose: false, vehicleNumber: ''
  };

  handleChange = (name) => event => {
    let value = event.target.value;
    value = value.trim() !== "" ? value.replace(/^./, value[0].toUpperCase()) : "";

    if (name === "mobile") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({[name]: value})
      }
      return;
    }
    if (name === "pin") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({[name]: value})
      }
      return;
    }
    if (name === "vehicleNumber"){
      value = value.toUpperCase();
      if(util.keyPressVehicleNumberValidation(value)){
        this.setState({[name]: value})
      }
      return;
    }
      this.setState({
        [name]: value
      })
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      [name]: value
    })
  };

  toggle = () => {
  };

  isValidate = () => {
    let condition = false;
    const {title, fname, lname, gender, mobile, email, vehicleNumber, department, designation, extention, identification_type, identification_value, isForward, forward_email} = this.state;
    if (fname.trim() === "" || lname.trim() === "" || mobile.trim() === "" || identification_value.trim() === "" ||
      email.trim() === "" || title.trim() === "" || gender.trim() === "" || identification_type.trim() === ""
    ) {
      fname.trim() === '' ? common.notifyMessage("Please enter your first name") :
        lname.trim() === '' ? common.notifyMessage("Please enter your last name") :
          mobile.trim() === '' ? common.notifyMessage("Please enter your mobile number") :
            identification_value.trim() === '' ? common.notifyMessage("Please enter your identity number") :
              common.notifyMessage("Please enter all required fields..")
    } else {
      if (util.mobileNumValidator(mobile)) {
        let validateEmail = EmailValidator.validate(email);
        if (validateEmail) {
          let isValid = util.identityValueValidator(identification_value, identification_type);
          if (isValid) {
            if(vehicleNumber.trim() !== ""){
              isValid = util.vehicleNumberPlateValidation(vehicleNumber.trim());
              if(!isValid){
                common.notifyMessage("Please enter valid vehicle number format. (AB-1234 or ABC-1234)",0,4);
                return;
              }
            }
            !this.state.isTerms ? common.notifyMessage("Please accept the Terms of Service to proceed") : condition = true
          }
        } else {
          common.notifyMessage("Invalid email address", 0, 2);
        }
      }
    }

    if (condition) {
      swal({
        title: "Are you sure, you want to proceed?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend(false);
            break;
          default:
            break;
        }
      });
    }
  };

  pinHandler = () => {
    if (this.state.pin.length === 5) {
      this.sendToBackend(true)
    } else {
      common.notifyMessage("Please enter OTP", 0, 2);
    }
  };

  sendToBackend = (isVerify) => {

    const {title, fname, lname, gender, mobile, email, company, department, designation, extention, identification_type, identification_value, mvid, refid, pin, screenshot,vehicleNumber} = this.state;
    const obj = {
      title: title,
      firstName: fname.trim(),
      lastName: lname.trim(),
      gender: gender,
      mobile: mobile,
      email: email.trim(),
      company: company.trim(),
      department: department.trim(),
      designation: designation.trim(),
      empId: null,
      extention: extention.trim(),
      identificationType: identification_type,
      identificationValue: identification_value.trim(),
      staffId: null,
      mvid: mvid,
      refid: refid,
      pin: pin.trim(),
      photoPath: screenshot,
      vehicleNumber: vehicleNumber.trim() === "" ? null: vehicleNumber.trim()
    };

    this.props.spinnerHandler(true);
    const headers = {
      "token": "Bearer " + this.state.token,
      "verify": isVerify
    };

    axios.post(apiConfig.USER, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          swal({
            title: "Registration Successfull! You will receive a QR code via Email & Onetime Meeting reference number to your mobile",
            icon: success_icon,
            closeOnClickOutside: false,
            buttons: {
              dangerMode: {
                text: "Okay",
                value: "action",
                className: "okay-btn"
              }
            },
          }).then((value) => {
            switch (value) {
              case "action":
                this.clearFields();
                window.close();
                break;
              default:
                this.clearFields();
                window.close();
                break;
            }
          });
        } else {
          if (response.data.error_code === 700) { //SEND_OTP_TO_VERIFY
            common.notifyMessage(response.data.message, 1);
            this.setState({
              isPin: true
            })
          } else if (response.data.error_code === 701) { //INCORRECT_OTP_SUBMITTED
            common.notifyMessage(response.data.message, 0);
            this.setState({
              isPin: true
            })
          } else {
            common.warningAlert(response.data.message, 1)
          }
        }
      })
      .catch(error => {
        if (error.response.status === 417) { //APPLICATION ERROR
          common.warningAlert("Something went wrong", 1)
        } else if (error.response.status === 403) {
          common.warningAlert(error.response.data.message, 1)
        } else {
          common.warningAlert("Something went wrong", 1)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  clearFields = () => {
    this.setState({
      title: 'Mr',
      fname: '',
      lname: '',
      gender: 'Male',
      mobile: '',
      email: '',
      company: '',
      department: '',
      designation: '',
      extention: '',
      identification_type: 'NIC',
      identification_value: '',
      mvid: '',
      refid: '',
      pin: '',
      access: true,
      token: null,
      isPin: false,
      isTerms: false,
      isClear: true,
      screenshot: '',vehicleNumber:''
    })
  };
  screenshotHandler = (screenshot) => {
    this.setState({
      screenshot: screenshot
    });
  };

  checkQueryString = () => {
    let queryParams = queryString.parse(window.location.search);
    let queryStringParam = queryParams.bWeu4e;

    if (queryStringParam === undefined) {
      this.setState({
        access: false
      })
    } else {
      this.decodeToken(queryStringParam)
    }
  };

  decodeToken = (queryStringParam) => {
    try {
      let decode_token = JWT_Decode(queryStringParam);
      let mvid = decode_token.mvid;
      let email = decode_token.sub;
      let refid = decode_token.refid;

      if (mvid === undefined || email === undefined || refid === undefined) {
        this.setState({
          access: false
        })
      } else {
        this.setState({
          mvid: mvid,
          email: email,
          refid: refid,
          token: queryStringParam,
          access: true
        })
      }
    } catch (e) {
      console.log("error", e);
      this.setState({
        access: false
      })
    }
  };


  notedHandler = () => {
    this.setState({
      warning_msg: "Registration postponed successfully."
    });
    this.clearFields();
    window.close();
  };

  componentDidMount() {
    this.checkQueryString();
    document.title = "Visitor Registration";
  }

  render() {
    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl" className={"reg-form-main-content"}>
          {
            this.state.isPin ?
              <MDBModal isOpen={true} toggle={this.toggle} size="md" className={"reg-form-main-content"}>
                <MDBModalHeader className={"registration-pin-title"} toggle={() => this.setState({isPin: false})}/>
                <div>
                  <h4 className={"reg-form-main-otp"}>Enter the verification code</h4>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={""}
                        placeholder={"Enter OTP"}
                        value={this.state.pin}
                        onChange={this.handleChange('pin')}
                      />
                    </Form.Group>
                    <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                      <Button className="px-5" onClick={this.pinHandler}>Send OTP</Button>
                    </Col>

                    {/*<small className={"pin-warning"} onClick={this.pinWarning}>Don't have access to your mobile? </small>*/}
                    <div className={"noted-wrapper"}>
                      <p className={"noted-p2"}>
                        {"If you don't have access to existing registered number '" + this.state.mobile + "', please change your profile by requesting the receptionist when visiting the Dialog premises."}
                      </p>
                      <div className={"noted-btn-wrapper"}>
                        <button className={"noted-btn"} onClick={this.notedHandler}>Okay</button>
                      </div>

                    </div>
                  </Form>
                  <br/>

                </div>
              </MDBModal> : null
          }

          <h4 className={"reg-form-main-topic"}>Visitor Registration</h4>
          <Row>

            <Col xs={12} lg={4} md={4}>
              <Form>
                <Form.Group widths='equal'>
                  <DrpDwn
                    required
                    tagText={"Title"}
                    placeholder={"Title"}
                    options={DropDownConst.userTitle}
                    value={this.state.title}
                    onChange={this.dropDownChange('title')}
                  />
                  <DrpDwn
                    required
                    tagText={"Gender"}
                    placeholder={"Gender"}
                    options={DropDownConst.gender}
                    value={this.state.gender}
                    onChange={this.dropDownChange('gender')}
                  />

                </Form.Group>
              </Form>
            </Col>

            <Col xs={12} lg={4} md={4}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={"First Name"}
                    placeholder={"First Name"}
                    value={this.state.fname}
                    onChange={this.handleChange('fname')}
                  />
                </Form.Group>
              </Form>
            </Col>

            <Col xs={12} lg={4} md={4}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={"Last Name"}
                    placeholder={"Last Name"}
                    value={this.state.lname}
                    onChange={this.handleChange('lname')}
                  />

                </Form.Group>
              </Form>
            </Col>

          </Row>

          <Row>
            <Col xs={12} lg={8} md={8}>
              <Row>

                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Mobile"}
                        placeholder={"07XXXXXXXX"}
                        value={this.state.mobile}
                        onChange={this.handleChange('mobile')}
                      />

                    </Form.Group>
                  </Form>
                </Col>

                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Email"}
                        placeholder={"Email Address"}
                        value={this.state.email}
                        // onChange={this.handleChange('email')}
                      />
                    </Form.Group>
                  </Form>
                </Col>


                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <DrpDwn
                        required
                        tagText={"Identification Type"}
                        placeholder={"Identification Type"}
                        options={DropDownConst.Identifications()}
                        value={this.state.identification_type}
                        onChange={this.dropDownChange('identification_type')}
                      />
                    </Form.Group>
                  </Form>
                </Col>

                <Col xs={12} lg={6} md={6}>
                  <Form.Group widths='equal'>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Identification Number"}
                          placeholder={"Identification Number"}
                          value={this.state.identification_value}
                          onChange={this.handleChange('identification_value')}
                        />

                      </Form.Group>
                    </Form>

                  </Form.Group>
                </Col>

                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        className={"optional"}
                        tagText={"Company"}
                        placeholder={"Company"}
                        value={this.state.company}
                        onChange={this.handleChange('company')}
                      />

                    </Form.Group>
                  </Form>
                </Col>

                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        className={"optional"}
                        tagText={"Department"}
                        placeholder={"Department"}
                        value={this.state.department}
                        onChange={this.handleChange('department')}
                      />

                    </Form.Group>
                  </Form>
                </Col>

                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        className={"optional"}
                        tagText={"Designation"}
                        placeholder={"Designation"}
                        value={this.state.designation}
                        onChange={this.handleChange('designation')}
                      />
                    </Form.Group>
                  </Form>
                </Col>

                <Col xs={12} lg={6} md={6}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        className={"optional"}
                        tagText={"Extension"}
                        placeholder={"Extension"}
                        value={this.state.extention}
                        onChange={this.handleChange('extention')}
                      />

                    </Form.Group>
                  </Form>
                </Col>

              </Row>

            </Col>
            <Col xs={12} md={4}>
              <Col xs={12} className={"none-padding"}>
                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      className={"optional"}
                      tagText={"Vehicle Number"}
                      placeholder={"AB-1234"}
                      value={this.state.vehicleNumber}
                      onChange={this.handleChange('vehicleNumber')}
                    />

                  </Form.Group>
                </Form>
              </Col>

              <Col xs={12} className={"none-padding"}>
                <p className={"p-optional"} style={{fontWeight: 600}}>Image</p>

                <div className={"align-center form-bottom"}>
                  <Form.Group>
                    <VisitorPhotoUpload screenshotHandler={this.screenshotHandler} screenshot={this.state.screenshot}/>
                    <p className={"or-text"}>OR</p>
                    <ImageUpload setScreenshot={(image) => this.setState({screenshot: image})}/>
                  </Form.Group>

                  {
                    this.state.screenshot !== "" ?
                      <img className={"view-image-reg-from"} src={this.state.screenshot} style={{
                        width: '200px',
                        height: '150px',
                        objectFit: 'scale-down',
                        // border: '1px #9a9a9a dotted',
                        boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
                        cursor: 'pointer'
                      }}/> : null
                  }
                </div>
              </Col>
            </Col>

            {
              this.state.access && !this.state.isClear ?
                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                  <Checkbox style={{cursor: 'pointer'}}
                            label={<label>I accept the <a target="_blank" href={'/vms_privacy_policy'}> Terms of
                              Service </a> | <a target="_blank" href={'https://www.dialog.lk/privacy-policy'}> Privacy
                              Policy</a>.</label>}
                            onChange={() => this.setState({isTerms: !this.state.isTerms})}
                            checked={this.state.isTerms}
                  />
                  <br/><br/>
                  <Button className="px-5" onClick={this.isValidate}>Submit</Button>

                </Col> : null
            }

          </Row>

        </MDBModal>
        {
          !this.state.access ?
            <div className={"warning-page"}>
              <i className="fa fa-exclamation-triangle" aria-hidden="true"/> Sorry you can't access this page!
            </div> : null
        }
        {
          this.state.isClear ?
            <div className={"warning-done-page"}>
              {this.state.warning_msg}
            </div> : null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
